import moment from 'moment';
import voca from 'voca';

export function formatDateTime(date) {
  return {
    date: moment(date).format('LL'),
    time: moment(date).format('LT')
  };
}

export function titleCase(str) {
  if (typeof str !== 'string') {
    return str;
  }

  return voca.titleCase(str);
}

export function millisToMinutesAndSeconds(millis) {
  const minutes = Number(millis / 60000).toFixed(1);
  const parts = minutes.split('.');
  const decimal = parts[1];

  if (Number(decimal) === 0) {
    return parts[0];
  }

  return minutes;
}

export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function withinMonth(date) {
  const monthStart = moment().startOf('month').valueOf();
  const monthEnd = moment().endOf('month').valueOf();

  return date >= monthStart && date <= monthEnd;
}

export function getSortFunction(item) {
  switch (item.key) {
    case '20_MIN_THRESHOLD':
      return (a, b) => {
        const prev = withinMonth(b.TimerDate) ? b.MinsLeft : 20;
        const next = withinMonth(a.TimerDate) ? a.MinsLeft : 20;

        if (item.sortOrder === 'ASC') {
          return prev - next;
        } else {
          return next - prev;
        }
      };

    case 'CALL_STATUS':
      return (a, b) => {
        if (item.sortOrder === 'ASC') {
          return a.LiveCallDate - b.LiveCallDate;
        } else {
          return b.LiveCallDate - a.LiveCallDate;
        }
      };

    case 'ENROLLMENT_DATE':
      return (a, b) => {
        if (item.sortOrder === 'ASC') {
          return a.EnrollStart - b.EnrollStart;
        } else {
          return b.EnrollStart - a.EnrollStart;
        }
      };

    case '30_DAYS_BILLING':
      return (a, b) => {
        const now = Date.now();
        const prev = b.BillingEnd - now;
        const next = a.BillingEnd - now;

        if (item.sortOrder === 'ASC') {
          return prev - next;
        } else {
          return next - prev;
        }
      };

    default:
      return () => null;
  }
}
